/** 
 * "Borrowed" from VSO codebase, https://mseng.visualstudio.com/VSOnline/_git/VSO?path=%2FTfs%2FService%2FWebAccess%2FPresentation%2FScripts%2FTFS%2FComponents%2FFormattedMessage.tsx&version=GBmaster&_a=contents
 * A React component conisting of a string 
 */

import * as React from "react";

export interface IFormattedMessageLink {
    /**
     * The link message to be displayed.
     */
    text: string;
    /**
     * The href for the link.
     */
    href?: string;
    /**
     * The target attribute for the link.
     */
    target?: string;
    /**
     * The onClick handler for the link action.
     */
    action?: (event?: React.MouseEvent<HTMLAnchorElement>) => void;
    /**
     * The role attribute to be applied to the anchor element.
     * If none is provided, role is "button"" if action is present, "link" otherwise.
     */
    role?: string;
}

export interface IFormattedMessageProps {
    /**
     * The message to be formatted with {#} substitutions.
     */
    message: string;
    /**
     * The links to be substituted in their respective {index} position into the message.
     */
    links?: IFormattedMessageLink[];
    /**
     * A class that is applied to the base span.
     */
    className?: string;
}

const splitRegex = /({\d+})/g;
const matchRegex = /{(\d+)}/;

export var FormattedMessage: React.StatelessComponent<IFormattedMessageProps> = (props: IFormattedMessageProps): JSX.Element => {
    if (!props.message) {
        return null;
    }

    if (!props.links || props.links.length === 0) {
        return <span>{props.message}</span>;
    }

    const segments = props.message.split(splitRegex);
    let children: JSX.Element[] = segments.map((segment, idx) => {
        let matches = segment.match(matchRegex);
        if (matches) {
            let index = parseInt(matches[1], 10);
            if (index >= 0 && index < props.links.length) {
                const link = props.links[index];
                const role = link.role || (link.action ? "button" : "link");
                return <span key={idx}>
                    <a href={link.href || null} role={role} onClick={link.action} target={link.target}>{link.text}</a>
                </span>;
            }
        }

        return <span key={idx}>{segment}</span>;
    });

    return <span className={props.className || ""}>
        {children}
    </span>;
};



// WEBPACK FOOTER //
// ./../Intercom.ReactUI/Views/FormattedMessage.tsx